/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelLastUserMessage} from '../api'

export const useMutationCancelLastUserMessage = createReactQueryMutationHook('cancelLastUserMessage', cancelLastUserMessage)
